module.exports = __webpack_public_path__ + "img/pc-list-one-add.b0b9f093.jpg";